export default "__VITE_ASSET__kNUQ74Uv__"